import { Component } from '@angular/core';
import { SubNavItem } from '../components/sub-navigation/sub-navigation.component';

@Component({
  selector: 'bwc-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
})
export class CompaniesComponent {
  subNavItems: SubNavItem[] = [
    { label: 'companies.sub_nav.for_you', route: '/profile-check/companies/for-you' },
    { label: 'companies.sub_nav.discover', route: '/profile-check/companies/discover' },
    { label: 'companies.sub_nav.new', route: '/profile-check/companies/new' },
    { label: 'companies.sub_nav.followed', route: '/profile-check/companies/followed' },
  ];
}
